import { formatDate } from "../formatDate";
import { getTruthyValue } from "@draftkings/sportsbook-common-utils";
const getStatText = (text, val) => val ? `${text} ${val}` : undefined;
export const parseReplayData = (replayData, pitchNumber, formatDateToFullMonthDayYear, dictionary) => {
    if (!replayData) {
        return undefined;
    }
    const { pitcherName, batterName, homeTeamName, awayTeamName, startEventDate, inningHalf, inningNumber, atBatNumber } = replayData;
    const inning = getTruthyValue(getStatText(dictionary.myBetsDictionary[inningHalf], inningNumber), "");
    const atBat = getTruthyValue(getStatText(dictionary.myBetsDictionary.AtBat, atBatNumber), "");
    const pitch = getTruthyValue(getStatText(dictionary.myBetsDictionary.Pitch, pitchNumber), "");
    const stats = [inning, atBat, pitch].filter(Boolean);
    return {
        pitcherName,
        batterName,
        eventName: `${homeTeamName} ${dictionary.myBetsDictionary.EventDelimiter} ${awayTeamName}`,
        startEventDate: formatDate(startEventDate, formatDateToFullMonthDayYear),
        stats,
    };
};
//# sourceMappingURL=parseReplayData.js.map